import {createSlice} from "@reduxjs/toolkit";
import {getSearchResultData,getSearchSelectResultData, getAllSearchResultData} from "../thunks/search";
import _ from "lodash";

const initialState = {
  loading: false,
  searchResultData: [],
  allSearchResultData: []
};

const searchSlice = createSlice({
  name: "searchSlice",
  reducers: {},
  initialState,

  extraReducers: (builder) => {
    builder

      /** Get all search data based on entered ItemNumber ----------------------------------------------------- **/ 
      .addCase(getSearchResultData.pending,(state,action) => {
        state.loading = true;
      })
      .addCase(getSearchResultData.fulfilled,(state,action) => {
        state.loading = false;
        state.allSearchResultData = action.payload;
      })
      .addCase(getSearchResultData.rejected,(state,action) => {
        state.loading = false;
      })

      /** Get data for specific item number ----------------------------------------------------- **/ 
      .addCase(getSearchSelectResultData.pending,(state,action) => {
        state.loading = true;
      })
      .addCase(getSearchSelectResultData.fulfilled,(state,action) => {
        let filterSelect = _.filter(state?.allSearchResultData,(d) => d.itemNumber === action.payload);
        state.loading = false;
        state.searchResultData = [...filterSelect];
      })
      .addCase(getSearchSelectResultData.rejected,(state,action) => {
        state.loading = false;
      })

      /** Get all data based on enter key pressed ----------------------------------------------------- **/
      .addCase(getAllSearchResultData.pending,(state,action) => {
        state.loading = true;
      })
      .addCase(getAllSearchResultData.fulfilled,(state,action) => {
        state.searchResultData = action.payload;
      })
      .addCase(getAllSearchResultData.rejected,(state,action) => {
        state.loading = false;
      });
  },
});

export default searchSlice;
